import { NavigationMenu } from '@/shared/components/ui/NavigationMenu';
import { Link, useLocation } from '@tanstack/react-router';
import { auth } from '@/core/firebase/config';
import { useAppLogo } from '@/shared/config/branding';
import { ChristmasLights } from '@/shared/components/ChristmasLights';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { IconUser, IconLayoutSidebarRight } from '@tabler/icons-react';
import { useSidebar } from '@/shared/providers/SidebarProvider';

interface NavbarProps {
  skeleton?: boolean;
}

export default function Navbar({ skeleton = false }: NavbarProps) {
  const Logo = useAppLogo();
  const location = useLocation();
  const { toggle } = useSidebar();
  const isLoginRoute = location.pathname === '/login';
  const isHomePageRoute = location.pathname === '/';

  if (isLoginRoute || isHomePageRoute) {
    return null;
  }

  const showSkeleton = skeleton || !auth.currentUser;

  return (
    <div className="sticky h-[72px]">
      <NavigationMenu className="p-4 h-full">
        <div className="flex w-full items-center justify-between gap-2">
          <div className="flex shrink-0 gap-4">
            <Link
              to="/booking"
              search={{
                resourceId: undefined,
                officeId: undefined,
                date: undefined,
                startTime: undefined,
                endTime: undefined,
              }}
            >
              <img src={Logo} alt="Robin Hoot" className="w-25 min-w-25" />
            </Link>
          </div>

          <ChristmasLights />

          {/* Mobile-only avatar trigger for sidebar */}
          <div className="shrink-0 lg:hidden">
            {showSkeleton ? (
              <Skeleton className="h-10 w-14 rounded-full" />
            ) : (
              <button
                onClick={toggle}
                aria-label="Open navigation menu"
                title="Open navigation menu"
                className="flex items-center gap-1.5 rounded-full px-1 py-1 hover:bg-accent transition-colors"
              >
                {auth.currentUser?.photoURL ? (
                  <img
                    src={auth.currentUser.photoURL}
                    alt={auth.currentUser.displayName || 'Profile'}
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center">
                    <IconUser className="w-5 h-5" />
                  </div>
                )}
                <IconLayoutSidebarRight className="w-5 h-5 text-muted-foreground" />
              </button>
            )}
          </div>
        </div>
      </NavigationMenu>
    </div>
  );
}
